(function(){
  if (window.__chatoniaLP) return; window.__chatoniaLP = true;
  var s = document.currentScript || document.querySelector('script[data-cart-add]');
  var ADD = (s && s.getAttribute('data-cart-add')) || '/cart/add';
  var CART = (s && s.getAttribute('data-cart')) || '/cart';
  function fmt(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; }
  function init(box){
    var dataEl = box.querySelector('.co-data'); if (!dataEl) return;
    var V = JSON.parse(dataEl.textContent);
    var main = box.querySelector('.co-main');
    var thumbs = box.querySelectorAll('.co-thumbs img');
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ main.src = t.dataset.big; thumbs.forEach(function(x){ x.classList.remove('on'); }); t.classList.add('on'); }); });
    var kits = box.querySelectorAll('.co-kit'), cols = box.querySelectorAll('.co-color'), adds = box.querySelectorAll('.co-add');
    function val(sel){ var o = box.querySelector(sel + '.on'); return o ? o.dataset.v : null; }
    function find(k, c){ for (var i = 0; i < V.length; i++){ if (V[i].o1 === k && (!c || V[i].o2 === c)) return V[i]; } return null; }
    function cur(){ return find(val('.co-kit'), val('.co-color')) || V[0]; }
    function upd(chg){
      var c = val('.co-color');
      kits.forEach(function(k){
        var v = find(k.dataset.v, c); if (!v) return;
        k.querySelector('img').src = v.th;
        k.querySelector('.co-kp').textContent = v.pm;
        var p = k.querySelector('.co-pct');
        if (v.c > v.p){ p.textContent = '-' + Math.round((v.c - v.p) * 100 / v.c) + '%'; p.style.display = ''; } else { p.style.display = 'none'; }
      });
      var v = cur();
      box.querySelector('.co-p').textContent = v.pm;
      var cm = box.querySelector('.co-c'), sv = box.querySelector('.co-save');
      if (v.c > v.p){ cm.textContent = v.cm; cm.style.display = ''; sv.textContent = 'ÉCONOMIE DE -' + Math.round((v.c - v.p) * 100 / v.c) + '%'; sv.style.display = ''; }
      else { cm.style.display = 'none'; sv.style.display = 'none'; }
      if (chg && v.img) main.src = v.img;
      var t = v.p, tc = Math.max(v.c, v.p);
      adds.forEach(function(a){ if (a.checked){ t += parseInt(a.dataset.cents, 10); tc += parseInt(a.dataset.cmp, 10); } });
      box.querySelector('.co-tot').textContent = fmt(t);
      box.querySelector('.co-totc').textContent = tc > t ? fmt(tc) : '';
    }
    kits.forEach(function(k){ k.addEventListener('click', function(e){ e.preventDefault(); kits.forEach(function(x){ x.classList.remove('on'); }); k.classList.add('on'); upd(true); }); });
    cols.forEach(function(k){ k.addEventListener('click', function(){ cols.forEach(function(x){ x.classList.remove('on'); }); k.classList.add('on'); upd(true); }); });
    adds.forEach(function(a){ a.addEventListener('change', function(){ upd(false); }); });
    var btn = box.querySelector('.co-btn'), err = box.querySelector('.co-err');
    var mo = box.querySelector('.co-mo'), go = mo && mo.querySelector('.co-mo-go');
    function items(){
      var it = [{ id: cur().id, quantity: 1 }];
      adds.forEach(function(a){ if (a.checked) it.push({ id: parseInt(a.value, 10), quantity: 1 }); });
      if (mo) mo.querySelectorAll('.co-mo-add.on').forEach(function(b){ it.push({ id: parseInt(b.dataset.id, 10), quantity: 1 }); });
      return it;
    }
    function send(b){
      b.disabled = true; err.textContent = '';
      fetch(ADD + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items() }) })
        .then(function(r){ if (!r.ok) throw 0; window.location.href = CART; })
        .catch(function(){ b.disabled = false; if (mo) close(); err.textContent = 'Oups, une erreur est survenue. Réessayez.'; });
    }
    function open(){ mo.hidden = false; document.documentElement.classList.add('co-lock'); requestAnimationFrame(function(){ mo.classList.add('in'); }); }
    function close(){ mo.classList.remove('in'); document.documentElement.classList.remove('co-lock'); setTimeout(function(){ mo.hidden = true; }, 200); }
    if (mo && mo.querySelector('.co-mo-add')) {
      document.body.appendChild(mo);
      mo.querySelector('.co-mo-x').addEventListener('click', close);
      mo.querySelector('.co-mo-bg').addEventListener('click', close);
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !mo.hidden) close(); });
      mo.querySelectorAll('.co-mo-add').forEach(function(b){ b.addEventListener('click', function(){
        var on = b.classList.toggle('on'); b.textContent = on ? '✓ Ajouté à ma commande' : '+ Ajouter à ma commande';
        go.firstChild.nodeValue = mo.querySelector('.co-mo-add.on') ? 'Valider et passer au panier ' : 'Continuer vers mon panier ';
      }); });
      go.addEventListener('click', function(){ send(go); });
      btn.addEventListener('click', open);
    } else {
      mo = null;
      btn.addEventListener('click', function(){ send(btn); });
    }
    upd(false);
  }
  function run(){ document.querySelectorAll('.co').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
